import React from 'react';
import { FormControl, FormControlLabel, Checkbox } from '@mui/material';

export type LabeledCheckboxProps = {
    className?: string;
    label: string;
    disabled: boolean;
    checked: boolean;
    onChange?: (value: boolean) => void;
}

export const LabeledCheckbox = (props: LabeledCheckboxProps) => {
    const { className, label, disabled, checked, onChange } = props;

    return (
        <FormControl className={className}>
            <FormControlLabel
                sx={{
                    marginLeft: theme => theme.spacing(0.5),
                    marginRight: theme => theme.spacing(0.5),
                }}
                disabled={disabled}
                control={
                    <Checkbox checked={checked} onChange={(_, c) => onChange ? onChange(c) : undefined} />
                }
                labelPlacement='start'
                label={label}
            />
        </FormControl>
    );
};
